// hooks/useCart.js
import { useState, useEffect } from "react";

export default function useCart() {
    const [cartItems, setCartItems] = useState([]);
    const [totalQuantity, setTotalQuantity] = useState(0);

    useEffect(() => {
        const updateCart = () => {
            const cart = JSON.parse(localStorage.getItem("cart")) || [];
            setCartItems(cart);
            const quantity = cart.reduce((sum, item) => sum + item.quantity, 0);
            setTotalQuantity(quantity);
        };

        // Подписка на событие обновления корзины
        window.addEventListener("cartUpdated", updateCart);
        updateCart();

        return () => window.removeEventListener("cartUpdated", updateCart);
    }, []);

    return { cartItems, totalQuantity };
}
